export enum Features {
    SCIENTIFIC_TEXT = 'scientific_text',
    QUESTION_ANSWER = 'question_answer',
    DEFENSE = 'defense',
    TRANSLATION = 'translation',
    IMPROVE_TEXT = 'improve_text'
}
